import type { IBimRelationshipEdge } from '@skystone/shared';
import type { IRoutedEdge } from '@/lib/bim-edge-routing';
import { cardinalityLabel, cardinalitySymbol, edgeColor } from '@/lib/bim-relationship-utils';

export interface BimEdgeProps {
  edge: IBimRelationshipEdge;
  routed: IRoutedEdge;
  isSelected: boolean;
  isDimmed: boolean;
  showLabel: boolean;
  onSelect: (edgeId: string) => void;
}

export function BimEdge({ edge, routed, isSelected, isDimmed, showLabel, onSelect }: BimEdgeProps) {
  const color = edgeColor(edge);
  const opacity = isDimmed ? 0.15 : isSelected ? 1 : 0.7;
  const strokeWidth = isSelected ? 2.5 : 1.5;
  const renderLabel = showLabel || isSelected;

  return (
    <g className="cursor-pointer" onClick={() => onSelect(edge.id)}>
      <path d={routed.path} stroke="transparent" strokeWidth={12} fill="none" />
      <path
        d={routed.path}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeOpacity={opacity}
        strokeDasharray={edge.isActive ? undefined : '5 4'}
        fill="none"
      />
      <circle cx={routed.from.x} cy={routed.from.y} r={2.5} fill={color} fillOpacity={opacity} />
      <circle cx={routed.to.x} cy={routed.to.y} r={2.5} fill={color} fillOpacity={opacity} />
      <text x={routed.from.x} y={routed.from.y - 4} textAnchor="middle" className="fill-muted-foreground text-[9px]" fillOpacity={opacity}>
        {cardinalitySymbol(edge.fromCardinality)}
      </text>
      <text x={routed.to.x} y={routed.to.y - 4} textAnchor="middle" className="fill-muted-foreground text-[9px]" fillOpacity={opacity}>
        {cardinalitySymbol(edge.toCardinality)}
      </text>
      {renderLabel && (
        <>
          <rect x={routed.labelX - 78} y={routed.labelY - 13} width={156} height={24} rx={5} fill="rgba(255,255,255,0.92)" fillOpacity={opacity} />
          <text x={routed.labelX} y={routed.labelY - 2} textAnchor="middle" className="fill-foreground text-[9px]" fillOpacity={opacity}>
            {`${edge.fromColumn} -> ${edge.toColumn}`}
          </text>
          <text x={routed.labelX} y={routed.labelY + 7} textAnchor="middle" className="fill-muted-foreground text-[9px]" fillOpacity={opacity}>
            {cardinalityLabel(edge)}
          </text>
        </>
      )}
    </g>
  );
}
